export const truncateText = (text: string, length = 80) => {
  if (text.length > length) {
    return `${text.substring(0, length)}...`;
  }
  return text;
};
